<template>
  <div>
    <div class="d-md-flex align-center justify-space-between fill-width">
      <h1 class="mb-0 mr-3">Invoicing</h1>
      <div class="d-md-flex align-center justify-space-between fill-width">
        <v-tooltip v-if="false" bottom max-width="300">
          <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >
          <i class="fa fa-info-circle" aria-hidden="true"></i>
        </span>
          </template>
          <span>Modifier added to the exchange rate when converting USD to EUR. Only the downloaded invoices will use this value. The table below will remain unchanged.</span>
        </v-tooltip>
        <span v-if="false" class="mr-3 ml-1">
          Invoice Currency Modifier
        </span>
        <v-text-field
                v-if="false"
                :rules="[rules.min, rules.max]"
                type="number"
                step="0.01"
                required
                class="shrink mr-3 v-text-field-modifier"
                v-model="currencyModifier"
        ></v-text-field>
        <v-spacer></v-spacer>

        <template>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on"  color="primary">
                Download
                <v-icon class="mr-2">mdi-download</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item link @click="downloadSelected('aggregated')">
                <v-list-item-title>Aggregated Report</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="downloadSelected('geo')">
                <v-list-item-title>GEO/Program Breakdown</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

      </div>
    </div>
    <div>
      <v-data-table
          :headers="table.headers"
          :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
          :items="advInvoices"
          :disable-sort="true"
          :loading="table.loading"
          :footer-props="{itemsPerPageOptions: table.pageOptions}"
          :items-per-page="table.perPage"
          :expanded.sync="table.expanded"
          :single-expand="false"
          item-key="period"
          show-expand
          loading-text="Loading... Please wait"
          fixed-header
          :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
          item-class="td_title"
          color="#7F98A5"
          :search="table.searchInInvoices"
          @pagination="updateTablePagination"
          :show-select="showSelect"
          @input="onSelect"
      >
        <template v-slot:top>
          <div class="period">
            <v-select
              :items="years"
              label="Pick the year"
              v-model="selectedYear"
              class="period-select"
              @change="onChangePeriod"
            ></v-select>
            <v-select
              :items="months"
              label="Pick the month"
              v-model="selectedMonth"
              class="period-select"
              @change="onChangePeriod"
            ></v-select>
          </div>
          <DataTableTopBar @search="table.searchInInvoices = $event" />
        </template>
        <template #item.data-table-select="{ item }">
          <v-checkbox
            v-if="ifCheckedPeriodsIndeterminate[item.period]"
            indeterminate
            @change="checkAllPeriodInvoices(item)"
          />
          <v-checkbox
            v-else
            :value="!!checkedInvoices[item.period] && (checkedInvoices[item.period].length === item.corps.length)"
            @change="checkAllPeriodInvoices(item)"
          />
        </template>
        <template #item.margin="{ item }">
          {{ item.margin }}%
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-0 ma-0">
            <v-simple-table class="ma-0 pa-0 scrollable-expand">
              <template v-slot:default>
                <tbody>
                  <tr
                      v-for="(value, index) in item.corps"
                      :key="index"
                  >
                    <td style="width: 90px"></td>
                    <td style="width: 50px">
                      <v-checkbox
                        :input-value="checkedInvoices[item.period].includes(value.corp_id) > 0"
                        @change="invoiceChecked(value.corp_id, item)"
                      />
                    </td>
                    <td style="width: 60px"></td>
                    <td class="spacer"></td>
                    <td style="width: 100px">{{value.name}}</td>
                    <td class="corp-name">
                      <span>{{value.corp_name}}</span>
                    </td>
                    <td style="width: 120px">{{value.sales}}</td>
                    <td style="width: 150px">{{numberPrettifier(value.cost)}}</td>
                    <td style="width: 180px">{{numberPrettifier(value.modifications)}}</td>
                    <td style="width: 180px">{{numberPrettifier(value.revenue.toFixed(2))}}</td>
                    <td style="width: 150px">{{numberPrettifier(value.revenue_eur)}}</td>
                    <td>{{value.margin * 100}}%</td>
                    <td>{{numberPrettifier(value.commissions)}}</td>
                    <td style="width: 160px">{{numberPrettifier(value.commissions_eur)}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </template>
        <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
          <data-filter
              type="range"
              :min="table.filters[header.value].min"
              :max="table.filters[header.value].max"
              v-if="table.filters.hasOwnProperty(header.value)"
              :items="table.filters[header.value].data"
              :entity="header.value"
              :values="table.filters[header.value].selected"
              @apply="submitFilter"
              @search="updateDataInFilters"
          />
          <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
            <span class="header_title">{{header.text}}</span>
            <v-icon
                size="16"
                color="#7F98A5"
            >
              mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}
            </v-icon>
          </a>
          <span v-else class="header_title">{{header.text}}</span>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import DataTableTopBar from '@/components/common/DataTableTopBar';
import {mapGetters} from 'vuex';
import store from "@/store";
import api from '../../../api/invoices';
import base64 from 'base-64';
import { numberWithCommas } from '@/helpers/numberWithCommas';
import logo from "../../common/logo";

export default {
  name: 'Invoicing',
  components: {
    DataTableTopBar
  },
  computed: {
    ...mapGetters('invoices', ['advInvoices']),
  },
  async mounted() {
    await this.getTableData()
    await this.getFiltersData()
  },
  methods: {
    numberPrettifier(data) {
      return numberWithCommas(data);
    },
    ifIndeterminate(item) {
      if(0 < this.checkedInvoices[item.period].length && this.checkedInvoices[item.period].length < item.corps.length) {
        this.ifCheckedPeriodsIndeterminate[item.period] = true
        this.$forceUpdate()
        return
      }
      this.ifCheckedPeriodsIndeterminate[item.period] = false
      this.$forceUpdate()
    },
    invoiceChecked(data, item) {
      if(this.checkedInvoices[item.period].indexOf(data) >= 0) {
        const index = this.checkedInvoices[item.period].indexOf(data)
        this.checkedInvoices[item.period].splice(index, 1)
        return this.ifIndeterminate(item)
      }
      this.checkedInvoices[item.period].push(data);
      this.ifIndeterminate(item)
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = column
      await this.getTableData()
    },
    onSelect(event) {
      if (event.length === 0) {
        Object.keys(this.advInvoices).forEach(value => {
          this.checkedInvoices[this.advInvoices[value].period] = []
        })
      } else if ((event.length === this.advInvoices.length) || (event.length === this.table.perPage)) {
        event.forEach(period => {
          this.checkedInvoices[period.period] = []
          period.corps.forEach(corp => {
            this.checkedInvoices[period.period].push(corp.corp_id)
          })
        })
      } else {
        Object.keys(this.checkedInvoices).forEach(value => {
          this.checkedInvoices[value] = []

          event.forEach(period => {
            if (value === period.period) {
              period.corps.forEach(corp => {
                this.checkedInvoices[period.period].push(corp.corp_id)
              })
            }
          })
        })
      }
    },
    addParamsToLocation(params) {
      const query = JSON.stringify(params) === '{}' ? this.$route.path :
          this.$route.path + '?' + Object.keys(params).map(
              key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
          ).join('&')
      history.pushState({},null, query);
    },
    updateTablePagination(params){
      if (
          (this.table.currentPage === params.page &&
              this.table.perPage === params.itemsPerPage) ||
          this.table.pageChangedByMe
      ) {
        this.table.pageChangedByMe = false;
        return
      }
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage
      /* if(this.$route.query.filters) {
        this.updateFiltersFromQuery();
      }
      this.getTableData(); */
    },
    async downloadSelected(reportType) {
      try {
        // force Currency Modifier to 0
        this.currencyModifier = 0;
        if (this.currencyModifier > 10 || this.currencyModifier < -10) {
          return;
        }
        this.$store.dispatch('alert/ALERT_SUCCESS', 'We are generating the invoice(s)');

        let preparedValues = []

        Object.keys(this.checkedInvoices).forEach(value => {
          if (this.checkedInvoices[value].length > 0) {
            this.checkedInvoices[value].forEach(selectedInvoice => {
              this.advInvoices.forEach(period => {
                if (period.period === value) {
                  period.corps.forEach(corp => {
                    if(corp.corp_id === selectedInvoice) {
                      const start = new Date(period.start)
                      const curStart = new Date(this.start)
                      const end = new Date(period.end)
                      const curEnd = new Date(this.end)

                      if(curStart > start) {
                        this.start = period.start
                      } else if (!this.start) {
                        this.start = period.start
                      }

                      if(curEnd < end) {
                        this.end = period.end
                      } else if (!this.end) {
                        this.end = period.end
                      }

                      preparedValues.push({
                        start: `'${period.start}'`,
                        end: `'${period.end}'`,
                        revenue: corp.revenue,
                        revenue_eur: corp.revenue_eur,
                        commissions: corp.commissions,
                        commissions_eur: corp.commissions_eur,
                        sales: corp.sales,
                        cost: corp.cost,
                        geo: corp.geo ? `'${corp.geo}'` : null,
                        program_id: corp.program_id ? `'${corp.program_id}'` : null,
                        program_name: corp.program_name ? `'${corp.program_name}'` : null,
                        corp_name: `'${corp.corp_name}'`,
                        corp_currency: `'${corp.corp_currency}'`,
                        corp_branding_theme: `'${corp.corp_branding_theme}'`,
                        corp_id: `'${corp.corp_id}'`,
                        corp_term: `'${corp.corp_term}'`,
                        name: `'${corp.name}'`,
                        rate: period.rate,
                        currency_modifier: this.currencyModifier
                      });
                    }
                  })
                }
              })
            })
          }
        })

        preparedValues = [... new Set(preparedValues)]

        const result = await api.downloadFiles({preparedValues, reportType});

        const docUrl = document.createElement('a');

        const startStr = this.start.toString().substr(0, 10);
        const endStr = this.end.toString().substr(0, 10);

        const prefix = reportType === 'geo' ? '_breakdown_' : '_aggregated_';

        docUrl.setAttribute('download', `${prefix}${startStr}-${endStr}.${result.type}`);

        if(result.type === 'zip') {
          docUrl.href = 'data:application/zip;base64,' + result.content;
        } else {
          docUrl.href = 'data:application/octet-stream;base64,' + result.content;
        }

        docUrl.click();

        this.start = ''
        this.end = ''

        this.$store.dispatch('alert/ALERT_SUCCESS', '');
      } catch (err) {
        console.error(err)
        this.$store.dispatch('alert/ALERT_ERROR', 'Something went wrong while downloading')
      }
    },
    async getFiltersData() {

      const res = await api.getFilter();
      Object.keys(this.table.filters).forEach(name => {
        if(res[name]) {
          res[name].forEach(filter => {
            this.table.filters[name].min = +filter.value < this.table.filters[name].min ? +filter.value : this.table.filters[name].min
            this.table.filters[name].max = +filter.value > this.table.filters[name].max ? +filter.value : this.table.filters[name].max
          })
        }

        this.table.filters[name].data = res[name]
      })
    },
    async submitFilter(data, entity) {
      this.table.currentPage = 1;
      if(data && entity) {
        this.table.filters[entity].selected = data;
      }
      return await this.getTableData()
    },
    async getTableData() {
      this.table.loading = true;
      this.activateFilters();
      const filters = await this.getFilters();
      await store.dispatch('invoices/getAdvInvoices', {
        payload: {
          limit: this.table.perPage,
          page: this.table.currentPage,
          orderBy: this.table.orderBy || '',
          orderDirectionAsc: this.table.sortColumnsAsc || false,
          filters: filters || null
        }
      })

      Object.keys(this.advInvoices).forEach(value => {
        this.checkedInvoices[this.advInvoices[value].period] = []
        this.ifCheckedPeriodsIndeterminate[this.advInvoices[value].period] = false
      })
      this.table.loading = false
    },
    activateFilters() {
      const filtersForQuery = {};
      for (const name in this.table.filters) {
        if(this.table.filters[name].selected.length > 0) {
          filtersForQuery[name] = this.table.filters[name].selected;
        }
      }
      this.addParamsToLocation(
          JSON.stringify(filtersForQuery) !== '{}' ? {filters: JSON.stringify(filtersForQuery)} : {}
      );
    },
    async getFilters() {
      const filters = {};
      filters['search'] = (this.table.searchInInvoices.length > 0) ? this.table.searchInInvoices : '';
      for(const name in this.table.filters) {
        filters[name] = (this.table.filters[name].selected.length > 0)
            ? `${this.table.filters[name].selected.join(',')}`
            : null;
      }
      if (this.selectedMonth) {
        filters['period'] = this.selectedMonth;
      }

      if (this.selectedYear) {
        filters['year'] = this.selectedYear;
      }

      return filters;
    },
    async updateDataInFilters(data, modalName) {
      if(modalName) {
        api.getFilter({
          filter: this.table.filters,
          name: modalName,
          searchFilter: data
        }).then(res => {
          this.table.filters[modalName].data = res;
        });
      }
    },
    checkAllPeriodInvoices(data) {
      this.start = !this.start ? data.start : this.start;
      this.end = !this.end ? data.end : this.end;

      if (this.checkedInvoices[data.period].length === data.corps.length) {
        this.checkedInvoices[data.period] = []
        this.$forceUpdate()
        return
      }

      data.corps.forEach(value => {
        this.checkedInvoices[data.period].push(value.corp_id);
      })

      this.$forceUpdate()
    },
    checkedInvoiceHandler(data) {
      if(this.checkedInvoices.includes(data)) {
        return this.checkedInvoices.splice(this.checkedInvoices.indexOf(data), 1);
      }
      this.checkedInvoices.push(data)
    },
    onChangePeriod() {
      if (!this.selectedMonth || !this.selectedYear) {
        return;
      }
      if(this.selectedMonth === 13) {
        this.selectedYear = null
      }
      this.getTableData();
    },
    getMonths() {
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const months = [];

      months.push({ value: 13, text: 'Default' });

      for (let i = 1; i <= 12; i++) {
        const monthName = monthNames[i - 1];
        months.push({ value: i, text: `${monthName}` });
      }

      return months;
    },

    getYears() {
      const now = DateTime.now();
      return [now.year - 1, now.year];
    }
  },
  data() {
    return {
      showSelect: true,
      start: '',
      end: '',
      checkedInvoices: {},
      ifCheckedPeriodsIndeterminate: {},
      currencyModifier: 0,
      selectedMonth: null,
      selectedYear: null,
      months: this.getMonths(),
      years: this.getYears(),
      rules: {
        min: v => ( v && v >= -10 ) || "Min value should be above -10.0",
        max: v => ( v && v <= 10 ) || "Max value should not be above 10.0",
      },
      table: {
        searchInInvoices: '',
        heightCounter: 45,
        currentPage: 1,
        perPage: 25,
        orderBy: '',
        sortColumnsAsc: true,
        pageOptions: [10, 25, 50, 100],
        loading: false,
        expanded: [],
        headers: [
          { text: 'Invoicing Period', value: 'periodDuration', class: 'color', align: 'center' }, //
          { text: 'Invoice #', value: 'name', align: 'center' }, //
          { text: 'Invoicee', value: 'count', align: 'center' }, //
          { text: 'Sales', value: 'sales', align: 'center' }, //
          { text: 'Cost (USD)', value: 'cost', align: 'center' }, //
          { text: 'Credit/Debit (USD)', value: 'modifications', align: 'center' }, //
          { text: 'Revenue (USD)', value: 'revenue', align: 'center' }, //
          { text: 'Revenue (EUR)', value: 'revenue_eur', align: 'center' }, //
          { text: 'Margin', value: 'margin', align: 'center' }, //
          { text: 'Commissions (USD)', value: 'commissions', align: 'center' }, //
          { text: 'Commissions (EUR)', value: 'commissions_eur', align: 'center' },
        ],
        filters: {
          //periodDuration: {selected: [], data: []},
          // name: {selected: [], data: []},
          //count: {selected: [], data: []},
          sales: {selected: [], data: [], min: 0, max: 1},
          cost: {selected: [], data: [], min: 0, max: 1},
          // credit_debit: {selected: [], data: []},
          revenue: {selected: [], data: [], min: 0, max: 1},
          revenue_eur: {selected: [], data: [], min: 0, max: 1},
          modifications: {selected: [], data: [], min: 0, max: 1},
          //margin: {selected: [], data: []},
          commissions: {selected: [], data: [], min: 0, max: 1},
          commissions_eur: {selected: [], data: [], min: 0, max: 1},
        }
      },
    }
  }
}
</script>

<style lang="sass">
  .v-label
    color: white !important
  .period-select .v-select__selection
    color: white !important
  .period
    position: fixed
    display: flex
    align-items: center
    gap: 16px
    margin-left: 3% !important
    color: whitesmoke !important
  .v-tooltip__content
    opacity: 1 !important
    background-color: #3A3852 !important
  .v-text-field-modifier
    width: 50px
  .scrollable-expand
    overflow-y: auto
    .v-data-table__wrapper
      height: auto !important
      .corp-name
        width: 120px
        span
          font-weight: 700
          color: var(--v-primary-base) !important
      .spacer
        width: 0
        padding-right: 40px
</style>
